import playInSlice, { PlayInSlice as _PlayInSlice } from './playInSlice'

export type PlayInSlice = _PlayInSlice
export const playInReducer = playInSlice.reducer
export const playInActions = playInSlice.actions
export default playInSlice
